import { useMemo } from "react";
import { createApplicationService } from "./base/applicationServiceBase";
import { AccountsAPI } from "api/axios.config";

const EXPENSES_BASE = "/Expenses";

const fetchExpensesAPI = () => AccountsAPI.get(`${EXPENSES_BASE}`);

const addNewExpenseAPI = (data) =>
  AccountsAPI.post(EXPENSES_BASE, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateExpenseAPI = (id, data) =>
  AccountsAPI.patch(`${EXPENSES_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const getMatterExpensesAPI = (matterId) =>
  AccountsAPI.get(`${EXPENSES_BASE}/Matter/${matterId}`);

const postMatterExpensesAPI = (matterId, data) =>
  AccountsAPI.post(
    `${EXPENSES_BASE}/Matter/${matterId}`,
    JSON.stringify({ data }),
    { headers: { "Content-Type": "application/json" } },
  );

const baseService = createApplicationService({
  name: "expenses",
  apiFetchFn: fetchExpensesAPI,
  apiAddFn: addNewExpenseAPI,
  apiUpdateFn: updateExpenseAPI,
});

const expenseReducer = baseService.reducer;
const getExpenses = baseService.getData;
const addExpense = baseService.addData;
const updateExpense = baseService.updateData;
const useExpenses = baseService.useData;

const getActiveExpenses = async () => {
  const expenses = await getExpenses();
  return expenses.filter((expense) => expense.active) || [];
};

const useActiveExpenses = () => {
  const { data, loading } = useExpenses();
  const activeExpenses = useMemo(
    () => data.filter((expense) => expense.active),
    [data]
  );
  return { data: activeExpenses, loading };
};

const getMatterExpenses = async (matterId) => {
  const res = await getMatterExpensesAPI(matterId);
  return res?.data?.data || [];
};

const postMatterExpenses = async (matterId, data) => {
  const res = await postMatterExpensesAPI(matterId, data);
  return res?.data;
};

export {
  expenseReducer,
  getExpenses,
  addExpense,
  updateExpense,
  getActiveExpenses,
  useExpenses,
  useActiveExpenses,
  getMatterExpenses,
  postMatterExpenses,
};
